// Normaliza um título de viagem em uma chave estável usável em cache:
//   "Eurotrip 2026"          → "eurotrip-2026"
//   "Porto de Galinhas"      → "porto-de-galinhas"
//   "Suíça · Alpes & Trens"  → "suica-alpes-trens"
//
// Usado em features/images/index.js como chave de
// `trip_images_cache/{slug}`. Mantém viagens com nomes iguais ou
// equivalentes (acentos, capitalização, pontuação) compartilhando cache.

export function slugify(input) {
  if (input == null) return '';
  return String(input)
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')   // remove diacríticos
    .replace(/[^a-z0-9]+/g, '-')        // qualquer não-alfanumérico vira hífen
    .replace(/^-+|-+$/g, '')             // tira hífens das pontas
    .slice(0, 60);                        // teto pra evitar slugs gigantes
}
